import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'babel-polyfill';
import {
	HttpUtils
} from './utils/HttpUtils'
import Tools from './utils/tools'
//import './utils/rem'
//import './assets/styles/variables.css'
import './assets/styles/global.css'
//import './assets/styles/animations.css'
//import '@fortawesome/fontawesome-free/css/all.css'

Vue.config.productionTip = false
Vue.use(Tools)
Vue.prototype.HttpUtils = HttpUtils

Vue.use(ElementUI)

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')